export const ReportVerification = Object.freeze({
  1: { text: "Verified", color: "#07B825" },
  2: { text: "Not Verified", color: "#D78E00" },
  3: { text: "Denied", color: "red" },
});

export const SymptomsStatus = Object.freeze({
  1: { text: "Normal", color: "#D2EECF" },
  2: { text: "Mild", color: "#FBEBB4" },
  3: { text: "Moderate", color: "#FFDBA1" },
  4: { text: "Severe", color: "#F8BDBD" },
});
